import React, { Component } from 'react';
import Header from '../../../components/Header/Header';

import boardLimit from '../../../assets/img/board-limit.svg'
// Import Style
import '../style.scss';

class GeneralError extends Component {
  render() {
    return (
      <div className='downtime'>
        <Header showHome={false} />

        <div className='downtime_wrap'>
          <div className='downtime_content'>
            <h1>Something Went Wrong</h1>
            <p>We're experiencing technical difficulties at the moment please try again later!</p>
            <a className='btn btn-primary' href="/login" id="loginBtn">
              Let's Try That Again
            </a>
          </div>
          
          <div className='downtime_icon'>
            <img alt="downtime icon" src={boardLimit}/>
          </div>
        </div>
      </div>
    );
  }
}
export default GeneralError;
